import {useState} from 'react'
import SubmitButtonRowDeleteSpecial from './components/SubmitButtonRowDeleteSpecial'
import {REMOVE_BULK_SPECIAL_TEMPLATE} from './core/_requests'
import SharedData from '../../common/SharedData'
import BulkDropzone from './components/BulkDropzone'

// Remove Discount - Bulk card — restyled to match the bulk-update / Add
// Discount - Bulk design (.adb-stack / .adb-card / BulkDropzone) while keeping
// its own remove-discount API implementation: the remove-discount template and
// SubmitButtonRowDeleteSpecial (the remove-by-bulk-special endpoint).
const RemoveDiscountBulkCard = () => {
  const {currentUser} = SharedData()

  const [bulkFile, setBulkFile] = useState<any>({
    value: null,
    error: false,
  })

  return (
    <div className='adb-stack'>
      {/* Steps 1 & 2 — download template + upload bulk sheet */}
      <section className='adb-card'>
        <BulkDropzone
          id='file'
          hasError={bulkFile.error}
          setField={setBulkFile}
          templateUrl={REMOVE_BULK_SPECIAL_TEMPLATE}
          token={currentUser?.token}
          user={currentUser}
        />
      </section>

      <SubmitButtonRowDeleteSpecial bulkFile={bulkFile} setBulkFile={setBulkFile} />
    </div>
  )
}

export default RemoveDiscountBulkCard
